/**
 * The current setup will only work effectively if there is
 * 1 tabs section on the page. Any more and they will interact
 * with each other.
 */
((Tabs) => {
  'use strict';

  const selectors = {
    shortableTextContainer: `[data-tabs-shortable]`,
  };

  const elements = {};

  const initLengthToggles = () => {
    elements.shortableTextContainers.forEach((container) => {
      const textElement = container.querySelector('[data-tabs-shortable-text]');
      if (!textElement) return;

      const maxHeight = textElement.dataset.tabsShortableText;

      if (!maxHeight || textElement.offsetHeight < maxHeight) {
        container.querySelector('[data-tabs-shortable-toggle]').style.display = 'none';
      } else {
        container.querySelector('[data-tabs-shortable-toggle]').style.display = 'block';
      }
    });
  };

  const toggleLength = (event) => {
    const parent = event.currentTarget.closest(selectors.shortableTextContainer);
    if (!parent) return;

    const text = parent.querySelector('[data-tabs-shortable-text]');

    event.currentTarget.classList.toggle('opened');

    if (event.currentTarget.classList.contains('opened')) {
      text.style.maxHeight = 'none';
    } else {
      text.style.maxHeight = `${text.dataset.tabsShortableText}px`;
    }
  };

  const toggleBody = (name) => {
    elements.tabBodies.forEach((body) => {
      if (body.getAttribute('data-tabs-body') === name) {
        body.classList.add('is-visible');
      } else {
        body.classList.remove('is-visible');
      }
    });
  };

  const toggleClick = (event) => {
    if (event.currentTarget.classList.contains('is-active')) return;

    const name = event.currentTarget.getAttribute('data-tabs-toggle');
    elements.tabToggles.forEach((toggle) => {
      toggle.classList.remove('is-active');
    });

    event.currentTarget.classList.add('is-active');
    toggleBody(name);
  };

  const setupElements = () => {
    elements.tabToggles = window.Helpers.toArray(document.querySelectorAll('[data-tabs-toggle]'));
    elements.tabBodies = window.Helpers.toArray(document.querySelectorAll('[data-tabs-body]'));
    elements.lengthToggles = window.Helpers.toArray(document.querySelectorAll('[data-tabs-shortable-toggle]'));
    elements.shortableTextContainers = window.Helpers.toArray(document.querySelectorAll(selectors.shortableTextContainer));
    initLengthToggles();
  };

  const bindUIActions = () => {
    $(selectors.shortableTextContainer).on(`contentChange`, initLengthToggles);
    elements.tabToggles.forEach((toggle) => {
      toggle.addEventListener('click', toggleClick);
    });

    elements.lengthToggles.forEach((toggle) => {
      toggle.addEventListener('click', toggleLength);
    });
  };

  const init = () => {
    setupElements();
    bindUIActions()
  };

  Tabs.init = init;
})(window.Tabs = window.Tabs || {});